export const appEvents = {
    /**
     * Dispatched when all components are initialized
     */
    initializationCompleted: 'initializationCompleted',
    /**
     * Dispatched when JSI is loaded
     * @deprecated
     */
    jsInterfacesLoaded: 'GemJsInterfacesLoaded',
    /**
     * Dispatched when JSI and all forms components (if any) are loaded
     */
    jsiCompleted: 'jsicompleted',
    /**
     * Dispatched when component's bundle start downloading to initialize
     */
    componentInitializationStart: 'componentinitializationstart',
    webComponentMount: 'webcomponentmount',
    hydrateWebComponentMount: 'hydratewebcomponentmount',
    webComponentUnmount: 'webcomponentunmount',
    componentUnmount: 'componentunmount',
};
